module.exports = __webpack_public_path__ + "static/media/ew_square.28ba3e47.png";